import { useState, useEffect } from 'react';

const services = [
  {
    title: 'Zona Social Exclusiva',
    desc: 'Área de reunión con parrillas, lounge y espacios diseñados para compartir momentos únicos entre propietarios.',
    img: '/assets/amenidades/zona-social.jpg',
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />,
  },
  {
    title: 'Área Deportiva Completa',
    desc: 'Canchas de tenis, fútbol y voleibol integradas en el entorno natural para un estilo de vida activo y saludable.',
    img: '/assets/amenidades/deportes.jpg',
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />,
  },
  {
    title: 'Restaurant & Minimarket',
    desc: 'Servicios gastronómicos y de aprovisionamiento dentro del condominio. Todo lo que necesitas sin salir del resort.',
    img: '/assets/amenidades/restaurant.jpg',
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />,
  },
  {
    title: 'Spa & Bienestar',
    desc: 'Instalaciones de relajación premium integradas con la naturaleza. Desconéctate y recarga energías en tu propio refugio.',
    img: '/assets/amenidades/spa.jpg',
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />,
  },
  {
    title: 'Gestión Airbnb',
    desc: 'Administración profesional de tu propiedad para alquiler vacacional. Genera ingresos sin preocuparte por la operación.',
    img: '/assets/amenidades/gestion-airbnb.jpg',
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />,
  },
  {
    title: 'Seguridad 24 / 7',
    desc: 'Condominio cerrado con acceso controlado y vigilancia permanente para que tu familia disfrute con total tranquilidad.',
    img: '/assets/amenidades/seguridad.jpg',
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />,
  },
];

export default function Services() {
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setLightbox(null); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  useEffect(() => {
    if (!lightbox) return;
    const onScroll = () => setLightbox(null);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [lightbox]);

  return (
    <section id="comodidades" className="px-8 md:px-16 py-20">
      <div className="text-center mb-12">
        <p className="text-xs tracking-[.28em] text-gray-400 uppercase font-medium mb-3">Comodidades</p>
        <h2 className="text-3xl md:text-4xl font-bold text-black leading-tight max-w-xl mx-auto">
          Explora todos los servicios y comodidades del resort
        </h2>
      </div>

      {/* Cards grid — max-width so they don't stretch across 4K screens */}
      <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {services.map((s) => (
          <div
            key={s.title}
            className="group bg-white rounded-2xl overflow-hidden hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
          >
            {/* Image with expand icon */}
            <div className="relative aspect-video overflow-hidden">
              <img
                src={s.img}
                alt={s.title}
                className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
              />
              {/* Expand button */}
              <button
                onClick={() => setLightbox(s)}
                className="absolute top-2.5 right-2.5 w-8 h-8 rounded-full
                  bg-black/30 backdrop-blur-sm border border-white/20
                  flex items-center justify-center
                  opacity-100 md:opacity-0 md:group-hover:opacity-100
                  hover:bg-black/60 hover:scale-110
                  transition-all duration-200"
                aria-label="Ver imagen completa"
              >
                <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 8V4m0 0h4M4 4l5 5m11-5h-4m4 0v4m0-4l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"/>
                </svg>
              </button>
            </div>

            {/* Content */}
            <div className="p-4">
              <div className="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center mb-2.5 group-hover:bg-black transition-colors duration-300">
                <svg className="w-3.5 h-3.5 text-gray-600 group-hover:text-white transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {s.icon}
                </svg>
              </div>
              <h3 className="font-semibold text-black mb-1 text-sm">{s.title}</h3>
              <p className="text-xs text-gray-500 leading-relaxed font-light">{s.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
          onClick={() => setLightbox(null)}
        >
          <div
            className="relative max-w-5xl w-full max-h-[90vh] rounded-2xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={lightbox.img}
              alt={lightbox.title}
              className="w-full h-full object-cover"
            />
            {/* Image label */}
            <div className="absolute bottom-0 inset-x-0 px-5 py-4 bg-gradient-to-t from-black/70 to-transparent">
              <p className="text-white font-semibold text-sm">{lightbox.title}</p>
              <p className="text-white/60 text-xs font-light mt-0.5">{lightbox.desc}</p>
            </div>
            {/* Close button */}
            <button
              onClick={() => setLightbox(null)}
              className="absolute top-3 right-3 w-9 h-9 rounded-full bg-black/40 backdrop-blur-sm
                border border-white/20 flex items-center justify-center
                hover:bg-black/70 hover:scale-110 transition-all duration-200"
              aria-label="Cerrar"
            >
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>
        </div>
      )}
    </section>
  );
}

